// extracted by mini-css-extract-plugin
export default {"container":"Trivia_container__-oIF5","header":"Trivia_header__cjfiF","content":"Trivia_content__+UpSN"};